module.exports = __webpack_public_path__ + "static/media/fig_11c.6ac72355.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_11c.gif
// module id = 630
// module chunks = 0